/* vd-proof-badge.js — Vape Dokha badge mounting, rationing, personalisation
 * Mount: move the server-rendered badge out of its <template> onto the card.
 * Ration: at most ONE coloured badge per visual row; the rest go quiet grey.
 * Personalise: on a later visit, a product this browser already viewed shows
 *   its demand badge — but only a claim the server already proved true, and
 *   never over 'Only N left'. localStorage only; no cookies, no network.
 */

(function () {
  'use strict';

  var VIEW_KEY = 'vd_views';
  var SID_KEY = 'vd_sid';
  var MAX_VIEWS = 60;
  var VIEW_TTL = 45 * 24 * 60 * 60 * 1000; // 45 days

  var PROMOTE_MIN_AGE = 20 * 60 * 1000; // 20 minutes
  var PROMOTE_MAX_AGE = 30 * 24 * 60 * 60 * 1000; // 30 days

  var MAX_COLOUR_PER_ROW = 1;

  var AR = /^ar/i.test(document.documentElement.lang || '');

  var LABELS = {
    trending: { text: AR ? 'الأكثر رواجًا الآن' : 'Trending now', tone: 'hot' },
    most_viewed: { text: AR ? 'الأكثر مشاهدة هذا الأسبوع' : 'Most viewed this week', tone: 'hot' }
  };

  var TONES = ['scarce', 'hot', 'best', 'fresh', 'quiet'];

  

  function safeParse(raw) {
    try {
      var v = JSON.parse(raw);
      return v && typeof v === 'object' ? v : {};
    } catch (e) {
      return {};
    }
  }

  function readViews() {
    try {
      return safeParse(localStorage.getItem(VIEW_KEY));
    } catch (e) {
      return {};
    }
  }

  function writeViews(views) {
    try {
      localStorage.setItem(VIEW_KEY, JSON.stringify(views));
    } catch (e) {
      
    }
  }

  function sessionId() {
    try {
      var sid = sessionStorage.getItem(SID_KEY);
      if (!sid) {
        sid = String(Date.now()) + '-' + Math.random().toString(36).slice(2, 8);
        sessionStorage.setItem(SID_KEY, sid);
      }
      return sid;
    } catch (e) {
      return 'nosession';
    }
  }

  function prune(views, now) {
    var handles = Object.keys(views);
    var i;

    for (i = 0; i < handles.length; i++) {
      if (!views[handles[i]] || now - views[handles[i]].t > VIEW_TTL) {
        delete views[handles[i]];
      }
    }

    handles = Object.keys(views);
    if (handles.length > MAX_VIEWS) {
      handles
        .sort(function (a, b) {
          return views[a].t - views[b].t;
        })
        .slice(0, handles.length - MAX_VIEWS)
        .forEach(function (h) {
          delete views[h];
        });
    }
    return views;
  }

  

  function recordView(handle) {
    if (!handle) return;

    var now = Date.now();
    var views = prune(readViews(), now);
    var prev = views[handle];

    views[handle] = {
      t: now,

      f: prev && prev.f ? prev.f : now,

      n: prev && prev.n ? prev.n + (prev.s === sessionId() ? 0 : 1) : 1,
      s: sessionId()
    };

    writeViews(views);
  }

  

  function isReturning(record, now) {
    if (!record) return false;
    if (record.s === sessionId()) return false; // same visit — nothing new to say
    var age = now - record.t;
    return age >= PROMOTE_MIN_AGE && age <= PROMOTE_MAX_AGE;
  }

  function applyTo(el, views, now) {
    if (el.hasAttribute('data-vd-swapped')) return;

    var flags = (el.getAttribute('data-flags') || '')
      .split(',')
      .map(function (f) {
        return f.trim();
      })
      .filter(Boolean);

    if (!flags.length) return;

    if (flags[0] === 'low_stock') return;

    var handle = el.getAttribute('data-handle');
    if (!isReturning(views[handle], now)) return;

    var promoted = null;
    if (flags.indexOf('trending') > -1) promoted = 'trending';
    else if (flags.indexOf('most_viewed') > -1) promoted = 'most_viewed';

    if (!promoted || promoted === flags[0]) return;

    var spec = LABELS[promoted];
    var textEl = el.querySelector('.vd-badge__text');
    if (!textEl) return;

    textEl.textContent = spec.text;

    TONES.forEach(function (t) {
      el.classList.remove('vd-badge--' + t);
    });
    el.classList.add('vd-badge--' + spec.tone);

    el.setAttribute('data-vd-swapped', promoted);
  }

  function applyAll(root) {
    var now = Date.now();
    var views = readViews();
    var nodes = (root || document).querySelectorAll('[data-vd-badge]');
    var i;
    for (i = 0; i < nodes.length; i++) {
      applyTo(nodes[i], views, now);
    }
  }

  

  function currentProductHandle() {
    var el = document.querySelector('[data-vd-pdp-handle]');
    if (el) return el.getAttribute('data-vd-pdp-handle');

    var m = window.location.pathname.match(/\/products\/([^/?#]+)/);
    return m ? decodeURIComponent(m[1]) : null;
  }

  
  var H1_SELECTORS = [
    '.product__title h1',
    '.product__title',
    '.product-single__title',
    'h1.product-title',
    '.product__info-container h1',
    'main h1',
  ];

  function mountPdpBadge() {
    var tpl = document.getElementById('vd-pdp-badge');
    if (!tpl || !tpl.content || !tpl.content.firstElementChild) return;
    if (document.querySelector('.vd-pdp-badge-row')) return;

    var title = null;
    for (var i = 0; i < H1_SELECTORS.length && !title; i++) {
      title = document.querySelector(H1_SELECTORS[i]);
    }
    if (!title) return;

    var row = document.createElement('div');
    row.className = 'vd-pdp-badge-row';
    row.appendChild(tpl.content.cloneNode(true));
    title.parentNode.insertBefore(row, title);
  }

  
  var CARD_ANCHORS = ['.card__inner', '.card__media', '.card-wrapper'];

  
  function avoidCollision(anchor, wrap) {
    var box = anchor.getBoundingClientRect();
    if (!box.width || !box.height) return;

    var mine = wrap.getBoundingClientRect();
    if (!mine.width) return;

    var all = anchor.querySelectorAll('div, span, img, a, p, svg');
    var lowest = 0;
    var i;

    for (i = 0; i < all.length; i++) {
      var el = all[i];
      if (wrap === el || wrap.contains(el) || el.contains(wrap)) continue;

      var r = el.getBoundingClientRect();
      if (r.width < 8 || r.height < 8) continue;

      if (r.width > box.width * 0.7 && r.height > box.height * 0.5) continue;

      var overlaps =
        r.left < mine.right && r.right > mine.left &&
        r.top < mine.bottom + 2 && r.bottom > box.top - 2;
      if (!overlaps) continue;

      var bottom = r.bottom - box.top;
      if (bottom > lowest) lowest = bottom;
    }

    if (lowest > mine.height) wrap.style.top = Math.round(lowest + 6) + 'px';
  }

  function mountCardBadges(root) {
    var tpls = (root || document).querySelectorAll('template.vd-badge-tpl');
    var i, j;

    for (i = 0; i < tpls.length; i++) {
      var tpl = tpls[i];
      if (tpl.getAttribute('data-vd-mounted')) continue;
      if (!tpl.content || !tpl.content.firstElementChild) {
        tpl.setAttribute('data-vd-mounted', '1');
        continue;
      }

      var anchor = null;
      for (j = 0; j < CARD_ANCHORS.length && !anchor; j++) {
        anchor = tpl.closest('.card-wrapper')
          ? tpl.closest('.card-wrapper').querySelector(CARD_ANCHORS[j])
          : null;
      }
      if (!anchor) {
        tpl.setAttribute('data-vd-mounted', '1');
        continue;
      }
      if (anchor.querySelector(':scope > .vd-badge-overlay')) {
        tpl.setAttribute('data-vd-mounted', '1');
        continue;
      }

      anchor.classList.add('vd-badge-anchor');
      var wrap = document.createElement('div');
      wrap.className = 'vd-badge-overlay';
      wrap.appendChild(tpl.content.cloneNode(true));
      anchor.insertBefore(wrap, anchor.firstChild);
      tpl.setAttribute('data-vd-mounted', '1');
      avoidCollision(anchor, wrap);

    }
  }

  
  var COLOUR = { scarce: 4, hot: 3, best: 2, fresh: 1 };

  function toneOf(el) {
    for (var k in COLOUR) if (el.classList.contains('vd-badge--' + k)) return k;
    return null;
  }

  function quieten(el) {
    var t = toneOf(el);
    if (!t) return;
    el.classList.remove('vd-badge--' + t);
    el.classList.add('vd-badge--quiet');
    el.setAttribute('data-vd-capped', t);
  }

  function rationRows(root) {
    var wraps = (root || document).querySelectorAll('.vd-badge-overlay');
    var rows = {};
    var i;

    for (i = 0; i < wraps.length; i++) {
      var b = wraps[i].querySelector('[data-vd-badge]');
      if (!b || !toneOf(b)) continue;
      var r = wraps[i].getBoundingClientRect();
      if (!r.height) continue;
      var key = Math.round((r.top + window.scrollY) / 40);
      (rows[key] = rows[key] || []).push(b);
    }

    Object.keys(rows).forEach(function (k) {
      var list = rows[k];
      if (list.length <= MAX_COLOUR_PER_ROW) return;
      list.sort(function (a, b) { return COLOUR[toneOf(b)] - COLOUR[toneOf(a)]; });
      for (var j = MAX_COLOUR_PER_ROW; j < list.length; j++) quieten(list[j]);
    });
  }

  function init() {
    var handle = currentProductHandle();
    if (handle) recordView(handle);
    mountPdpBadge();
    mountCardBadges(document);
    applyAll(document);
    rationRows(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Images load late and change what sits in the corner, and row positions
  // only settle once they have. Re-dodge and re-ration after the page is done.
  window.addEventListener('load', function () {
    setTimeout(function () {
      var wraps = document.querySelectorAll('.vd-badge-overlay');
      for (var i = 0; i < wraps.length; i++) {
        wraps[i].style.top = '';
        avoidCollision(wraps[i].parentElement, wraps[i]);
      }
      rationRows(document);
    }, 600);
  });

  document.addEventListener('shopify:section:load', function (e) {
    mountCardBadges(e.target);
    applyAll(e.target);
    rationRows(document);
  });

  if (window.MutationObserver) {
    var pending = null;
    var mo = new MutationObserver(function () {
      if (pending) return;
      pending = setTimeout(function () {
        pending = null;
        mountCardBadges(document);
        applyAll(document);
        rationRows(document);
      }, 250);
    });
    var target = document.getElementById('MainContent') || document.body;
    if (target) mo.observe(target, { childList: true, subtree: true });
    window.addEventListener('load', function () {
      setTimeout(function () {
        try { mo.disconnect(); } catch (e) {}
      }, 8000);
    });
  }

  window.VDProofBadge = {
    refresh: function (root) {
      mountCardBadges(root || document);
      applyAll(root || document);
      rationRows(document);
    },
    mount: mountCardBadges,
    record: recordView,
    views: readViews,
    clear: function () {
      try {
        localStorage.removeItem(VIEW_KEY);
      } catch (e) {}
    }
  };
})();
